import { Probabilidad } from './probabilidad.model';
import { Impacto } from './impacto.model';
import { DimensionRiesgo } from './dimension-riesgo.model';

export class AnalisisInherente
{
    id: number;
    probabilidad: Probabilidad;
    categoria: string;
    dimension: DimensionRiesgo;
    impacto: Impacto;
    exposicion: number;
    clasificacion: string;

    /**
     * Constructor
     *
     * @param analisis
     */
    constructor(analisis)
    {
        {
            this.id = analisis.id || null;
            this.probabilidad = analisis.probabilidad || null;
            this.categoria = analisis.categoria || '';
            this.dimension = analisis.dimension || null;
            this.impacto = analisis.impacto || null;
            this.exposicion = analisis.exposicion || 0;
            this.clasificacion = analisis.clasificacion || '';
        }
    }
}
